import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcVeryPoor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 57,
	viewBox: "0 0 56 57",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 27.9922,
		cy: 28.668,
		r: 22,
		fill: "#D2D9E0"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M24.1851 21.891C24.6137 21.9982 24.8744 22.4325 24.7672 22.8611C24.3627 24.4789 22.4272 27.4671 17.9911 27.4671C17.5493 27.4671 17.1911 27.1089 17.1911 26.6671C17.1911 26.2253 17.5493 25.8671 17.9911 25.8671C21.5549 25.8671 22.9527 23.522 23.215 22.4731C23.3221 22.0444 23.7565 21.7838 24.1851 21.891ZM27.9911 32.6671C22.4234 32.6671 20.6515 37.0955 20.1595 38.9078C20.0939 39.1494 20.4088 39.3404 20.6236 39.2119C21.61 38.6217 23.846 37.6671 27.9911 37.6671C32.1362 37.6671 34.3722 38.6217 35.3586 39.2119C35.5733 39.3404 35.8882 39.1494 35.8226 38.9078C35.3306 37.0955 33.5588 32.6671 27.9911 32.6671ZM31.2111 22.8611C31.1039 22.4325 31.3645 21.9982 31.7931 21.891C32.2218 21.7838 32.6561 22.0444 32.7633 22.4731C33.0255 23.522 34.4233 25.8671 37.9872 25.8671C38.429 25.8671 38.7872 26.2253 38.7872 26.6671C38.7872 27.1089 38.429 27.4671 37.9872 27.4671C33.551 27.4671 31.6155 24.4789 31.2111 22.8611Z",
		fill: "white"
	})]
});
export default SvgIcVeryPoor;
